export function editing({commit}, editing) {
	commit('editing', {editing})
}
